export var timeseriesOptions = {
  credits: {
    enabled: false
  },
  accessibility: {
    enabled: false
  },
  chart: {
    backgroundColor: 'transparent',
    height: 120
  },
  xAxis: {
    visible: false
  },
  yAxis: {
    minPadding: 0,
    maxPadding: 0,
    visible: false,
    opposite: false,
    showFirstLabel: false,
    lineColor: 'rgb(204, 204, 204)',
    labels: {
      align: 'right',
      format: '{value:.0f}%'
    }
  },
  scrollbar: {
    enabled: false
  },
  navigator: {
    enabled: false
  },
  series: [],
  legend: {
    enabled: false
  },
  rangeSelector: {
    enabled: false
  },
  title: {
    text: ''
  },
  tooltip: {
    enabled: false
  }
};